const base = (process.env.VUE_APP_API_URL || '/api').replace(/\/$/, '')
export async function request(path, token, options = {}) {
  const response = await fetch(base + path, {
    ...options,
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}), ...options.headers }
  })
  const data = await response.json().catch(() => ({}))
  if (!response.ok) throw new Error(typeof data.detail === 'string' ? data.detail : 'İşlem tamamlanamadı. Alanları kontrol et.')
  return data
}
export function socketUrl(token) {
  const url = new URL(base + '/ws', window.location.origin)
  url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:'
  url.searchParams.set('token', token)
  return url.toString()
}
